module.exports = __webpack_public_path__ + "img/agenda_04.c229ce3d.jpg";